"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useFeatureToggles = require("./useFeatureToggles");
Object.keys(_useFeatureToggles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFeatureToggles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useFeatureToggles[key];
    }
  });
});
